import React, { useState, useEffect, useContext } from "react";
import classes from "./confirmlanes.module.css";
import Axios from "../../../../../../Axios";
import { Urls } from "../../../../../../Urls";
import Loader from "../../../../../Loader";
import { Suggestion, TransporterSuggest, next_page } from "../Utility";
import Select from "react-select/creatable";
import { toast } from "react-toastify";
import { Activity, currentRequestTimeStamp } from "../../../../../../Constants";
//import AutoComplete from "../../../../../CompanyProfileNew/FreightMaster/FreightMaster/UploadExcel/AutoComplete/AutoComplete";
import AutoComplete from "../../../../../Shared/AutosuggestV2/Autosuggestv2";
import { closeModal } from "../../../../../Indent/InvoiceV2/utils";
import { MyCompanyProfileContext } from "../../../../../../MyCompanyProfileContext";
import axios from "../../../../../../Axios";
import { MastersChangeLog } from "../../../../Utility";
import { UserApiContext } from "../../../../../UserDetailsContext/UserDetailsContext";
import { sendMailToMasters } from "../../../Utility/utility";
import { useMixPanelForTracking } from "../../../../../../utils/TrackMixPanel";


/**
 * Step 5 - reviews all details
 * ConfirmLanes component for reviewing and confirming uploaded freight master .
 *
 * @param {number} step - current step in process.
 * @param {React.SetStateAction} setStep - setter to update current step.
 * @param {number} PreviosStep - previous step in process.
 * @param {React.SetStateAction} setPreviosStep - setter to update previous step.
 * @param {function} fetch_saved_details - Function to fetch saved details.
 * @param {Object} excel_details - Details of Excel file.
 * @param {function} setDetails - Function to update details.
 * @returns {JSX.Element}
 */
const ConfirmLanes = ({
  step = 4,
  setStep = "",
  PreviosStep = 3,
  setPreviosStep = "",
  fetch_saved_details = "",
  excel_details = {},
  setDetails = "",
  isBulkUpload,
  headerMap,
  floatFromFM,
  setExistingLanes,
  setValidationErrors,
  emailTemplate,
  superAdmins,
}) => {
  const [maxnooftransporter, setMaxnooftransporter] = useState(3);
  const [show, setshow] = useState(false);
  const [lane_details, setlane_details] = useState([]);
  const [truckTypes, setTruckTypes] = useState([]);
  const { userDetails, companyProfile } = useContext(UserApiContext);
  const { companySettingData } = useContext(MyCompanyProfileContext);
  const { TrackMixPanel } = useMixPanelForTracking(userDetails, companySettingData);
  useEffect(() => {
    getTruckTypes();
    Axios.post(`${Urls.freight_master}?action=read_excel_file`, {
      file_url: excel_details.blob_url,
      ...(isBulkUpload && { mapping_header: headerMap }),
    })
      .then((response) => {
        setshow(true);
        Axios.post(`${Urls.freight_master}?action=get_saved_data`, {
          excel_id: excel_details.excel_id,
        }).then(async (res) => {
          if (response.data.length > 0) {
            var lanedetails = [];
            for (var i = 0; i < response.data.length; i++) {
              var details = {
                origin: await getOrigin(
                  res.data.unique_df,
                  res.data.multistate,
                  res.data.not_found_new,
                  res.data.no_spellsugg,
                  response.data[i]
                ),
                destination: await getDestination(
                  res.data.unique_df,
                  res.data.multistate,
                  res.data.not_found_new,
                  res.data.no_spellsugg,
                  response.data[i]
                ),
                truck_type: await getTruckDetails(
                  res.data.trk_matched,
                  res.data.trk_spell,
                  response.data[i],
                  i
                ),
                volume: response.data[i]["Annual Volume*"],
                transit_time: response.data[i]["Transit Time (Days)*"],
                baseline_rate: response?.data[i]["Baseline"]
                  ? parseInt(response?.data[i]["Baseline"])
                  : 0,
                market_rate: response?.data[i]["Market Rate"]
                  ? parseInt(response?.data[i]["Market Rate"])
                  : 0,
                site_rate: response?.data[i]["Site Rate"]
                  ? parseInt(response?.data[i]["Site Rate"])
                  : 0,
                challenge_price: response?.data[i]["Challenge Price"]
                  ? parseInt(response?.data[i]["Challenge Price"])
                  : 0,
                distance: response.data[i]["Distance (Km)"],
                unit: response.data[i]["Unit"],
                zone: response.data[i]["Zone"],
                route_code: response.data[i]["Route Code"],
                good_type: response.data[i]["Type of Good"],
                transporter_details: await getTransporter(
                  res.data.ven_matched,
                  res.data.ven_spell,
                  response.data[i]
                ),
                placement_date: response.data[i]["Date of Placement"],
              };
              lanedetails.push(details);
              if (i === response.data.length - 1) {
                setlane_details(lanedetails);
                TrackMixPanel({
                  moduleName: "masters",
                  screenName: "freight master confirm lanes",
                  definition: "lane data successfully loaded from excel",
                  data: `records: ${lanedetails.length}, excel_id: ${excel_details.excel_id}`,
                });
              }
            }
          }
          setshow(false);
        });
      })
      .catch((e) => {
        console.error(e);
      });
  }, [excel_details]);

  /**
   * Checks if a lane is already present in lane_details array.
   * @param {Array<Object>} lanes - array of lane details.
   * @param {Object} lane - lane object to check.
   * @returns {boolean} - True if lane is already present, false otherwise.
   */
  const get_lane_present = (lanes, lane) => {
    for (var i = 0; i < lanes.length; i++) {
      if (
        lanes[i]?.origin?.location_code !== null &&
        lanes[i]?.destination.location_code !== null
      ) {
        if (
          lanes[i]?.origin?.location_code === lane.origin.location_code &&
          lanes[i]?.destination?.location_code ===
          lane.destination.location_code &&
          lanes[i].truck_type.label === lane.truck_type.label
        ) {
          return true;
        }
      } else if (
        lanes[i]?.origin?.location_name === lane.origin.location_name &&
        lanes[i]?.destination?.location_name ===
        lane.destination.location_name &&
        lanes[i].truck_type.label === lane.truck_type.label
      ) {
        return true;
      }
    }
    return false;
  };

  /**
   * Retrieves origin location details for a given row of data.
   * @param {Array<Object>} unique_df - unique data frame.
   * @param {Array<Object>} multistate - multistate data frame.
   * @param {Array<Object>} not_found_new - not found new data frame.
   * @param {Array<Object>} no_spellsugg - no spell suggestion data frame.
   * @param {Object} details - row of data.
   * @returns {Object} - origin location details.
   */
  const getOrigin = async (
    unique_df,
    multistate,
    not_found_new,
    no_spellsugg,
    details
  ) => {
    var origin = {};
    // console.log(details['Origin Name*'], details['Origin State*'])
    for (var i = 0; i < unique_df.length; i++) {
      if (unique_df[i]["Raw Location ID"]) {
        if (unique_df[i]["Raw Location ID"] === details["Origin ID"]) {
          origin = unique_df[i]["main_location"];
          break;
        }
      } else {
        if (
          unique_df[i]["Raw Location"] === details["Origin Name*"] &&
          unique_df[i]["Raw State"] === details["Origin State*"]
        ) {
          origin = unique_df[i]["main_location"];
          break;
        }
      }
    }
    for (var j = 0; j < multistate.length; j++) {
      if (multistate[j]["Raw Location ID"]) {
        if (multistate[j]["Raw Location ID"] === details["Origin ID"]) {
          origin = multistate[j]["main_location"];
          break;
        }
      } else {
        if (
          multistate[j]["Raw Location"] === details["Origin Name*"] &&
          multistate[j]["Raw State"] === details["Origin State*"]
        ) {
          origin = multistate[j]["main_location"];
          break;
        }
      }
    }
    for (var k = 0; k < not_found_new.length; k++) {
      if (not_found_new[k]["Raw Location ID"]) {
        if (not_found_new[k]["Raw Location ID"] === details["Origin ID"]) {
          origin = not_found_new[k]["main_location"];
          break;
        }
      } else {
        if (
          not_found_new[k]["Raw Location"] === details["Origin Name*"] &&
          not_found_new[k]["Raw State"] === details["Origin State*"]
        ) {
          origin = not_found_new[k]["main_location"];
          break;
        }
      }
    }
    for (var l = 0; l < no_spellsugg.length; l++) {
      if (no_spellsugg?.[j]["Raw Location ID"]) {
        if (no_spellsugg?.[j]["Raw Location ID"] === details["Origin ID"]) {
          origin = no_spellsugg?.[j]["main_location"];
          break;
        }
      } else {
        if (
          no_spellsugg[l]["Raw Location"] === details["Origin Name*"] &&
          no_spellsugg[l]["Raw State"] === details["Origin State*"]
        ) {
          origin = no_spellsugg[l]["main_location"];
          break;
        }
      }
    }
    // console.log(origin)
    return origin;
  };

  /**
   * Retrieves destination location details for a given row of data.
   * @param {Array<Object>} unique_df - unique data frame.
   * @param {Array<Object>} multistate - multistate data frame.
   * @param {Array<Object>} not_found_new - not found new data frame.
   * @param {Array<Object>} no_spellsugg - no spell suggestion data frame.
   * @param {Object} details - row of data.
   * @returns {Object} - destination location details.
   */
  const getDestination = async (
    unique_df,
    multistate,
    not_found_new,
    no_spellsugg,
    details
  ) => {
    var destination = {};
    for (var m = 0; m < unique_df.length; m++) {
      if (unique_df[m]["Raw Location ID"]) {
        if (unique_df[m]["Raw Location ID"] === details["Destination ID"]) {
          destination = unique_df[m]["main_location"];
          break;
        }
      } else {
        if (
          unique_df[m]["Raw Location"] === details["Destination Name*"] &&
          unique_df[m]["Raw State"] === details["Destination State*"]
        ) {
          destination = unique_df[m]["main_location"];
          break;
        }
      }
    }
    for (var n = 0; n < multistate.length; n++) {
      if (multistate[n]["Raw Location ID"]) {
        if (multistate[n]["Raw Location ID"] === details["Destination ID"]) {
          destination = multistate[n]["main_location"];
          break;
        }
      } else {
        if (
          multistate[n]["Raw Location"] === details["Destination Name*"] &&
          multistate[n]["Raw State"] === details["Destination State*"]
        ) {
          destination = multistate[n]["main_location"];
          break;
        }
      }
    }
    for (var o = 0; o < not_found_new.length; o++) {
      if (not_found_new[o]["Raw Location ID"]) {
        if (not_found_new[o]["Raw Location ID"] === details["Destination ID"]) {
          destination = not_found_new[o]["main_location"];
          break;
        }
      } else {
        if (
          not_found_new[o]["Raw Location"] === details["Destination Name*"] &&
          not_found_new[o]["Raw State"] === details["Destination State*"]
        ) {
          destination = not_found_new[o]["main_location"];
          break;
        }
      }
    }
    for (var p = 0; p < no_spellsugg.length; p++) {
      if (no_spellsugg[p]["Raw Location ID"]) {
        if (no_spellsugg[p]["Raw Location ID"] === details["Destination ID"]) {
          destination = no_spellsugg[p]["main_location"];
          break;
        }
      } else {
        if (
          no_spellsugg[p]["Raw Location"] === details["Destination Name*"] &&
          no_spellsugg[p]["Raw State"] === details["Destination State*"]
        ) {
          destination = no_spellsugg[p]["main_location"];
          break;
        }
      }
    }
    return destination;
  };

  /**
   * Retrieves truck details for a given row of data.
   * @param {Array<Object>} trk_matched - matched truck types.
   * @param {Array<Object>} trk_spell - truck types with spelling suggestions.
   * @param {Object} details - row of data.
   * @param {number} index - index of row.
   * @returns {Object} - truck details.
   */
  const getTruckDetails = async (trk_matched, trk_spell, details) => {
    var truck = {};
    for (var i = 0; i < trk_matched.length; i++) {
      if (details["Truck Type*"] === trk_matched[i]["Truck"]) {
        truck = {
          label: trk_matched[i]["label"],
          value: trk_matched[i]["value"],
        };
        break;
      }
    }
    for (var j = 0; j < trk_spell.length; j++) {
      if (details["Truck Type*"] === trk_spell[j]["Truck"]) {
        truck = {
          label: trk_spell[j]["label"],
          value: trk_spell[j]["value"],
        };
        break;
      }
    }
    return truck;
  };

  /**
   * Retrieves total number of transporters and their details for a given row of data.
   * @param {Object} details - row of data.
   * @returns {Object[]} - array of transporter details.
   */
  const get_total_transporters = async (details) => {
    var transporters = [];
    var count = 0;
    Object.keys(details).map((key) => {
      if (key.includes("Transporter")) {
        count = count + 1;
      }
    });
    Array.apply(0, Array(count / 3)).map((x, m) => {
      transporters.push({ name: "", rate: "", business_share: "" });
    });
    setMaxnooftransporter(
      count / 3 > maxnooftransporter ? count / 3 : maxnooftransporter
    );
    Object.keys(details).map((key, index) => {
      if (key.includes("Transporter")) {
        transporters[parseInt(key.split(" ")[0].split("L")[1]) - 1].rank =
          parseInt(key.split(" ")[0].split("L")[1]);
        if (key.includes("Name") && details[key]) {
          transporters[parseInt(key.split(" ")[0].split("L")[1]) - 1].name =
            details[key];
        }
        if (key.includes("Freight Rate") && details[key]) {
          transporters[parseInt(key.split(" ")[0].split("L")[1]) - 1].rate =
            details[key];
        }
        if (key.includes("Share of business") && details[key]) {
          transporters[
            parseInt(key.split(" ")[0].split("L")[1]) - 1
          ].business_share = details[key];
        }
      }
    });
    return transporters;
  };

  /**
   * Retrieves transporter details for a given row of data.
   * @param {Array<Object>} ven_matched - matched transporters.
   * @param {Array<Object>} ven_spell - transporters with spelling suggestions.
   * @param {Object} details - row of data.
   * @returns {Array<Object>} - array of transporter details.
   */
  const getTransporter = async (ven_matched, ven_spell, details) => {
    var cleaned_transporter_list = [],
      transporter_list = [];
    for (var i = 0; i < ven_matched.length; i++) {
      cleaned_transporter_list.push(ven_matched[i]);
    }
    for (var j = 0; j < ven_spell.length; j++) {
      cleaned_transporter_list.push(ven_spell[j]);
    }
    cleaned_transporter_list.sort((a, b) => a.index - b.index);
    var transporters = await get_total_transporters(details);
    for (var k = 0; k < transporters.length; k++) {
      for (var l = 0; l < cleaned_transporter_list.length; l++) {
        if (transporters[k].name === cleaned_transporter_list[l]["Vendor"]) {
          transporter_list.push({
            transporter: cleaned_transporter_list[l].transporter,
            rate: transporters[k].rate,
            business_share: transporters[k].business_share,
            rank: transporters[k].rank,
          });
          break;
        }
      }
    }
    return transporter_list;
  };

  /**
   * Retrieves list of truck types.
   */
  const getTruckTypes = () => {
    Axios.get(`${Urls.Autocomplete.Get.getlist}?searchFields=truck`)
      .then((res) => {
        setTruckTypes(
          res.data.map((item) => {
            if (item.name) return { label: item.name, value: item.name };
          })
        );
      })
      .catch((err) => { });
  };

  /**
   * Handles change of truck type for a lane.
   * @param {Object} e - selected truck type.
   * @param {Object} lane - lane object.
   * @param {number} index - index of lane.
   */
  const onChangeTruckType = (e, lane, index) => {
    var temp = lane_details.map((l, i) => {
      if (i === index) {
        l["truck_type"] = e;
      }
      return l;
    });
    setlane_details(temp);
  };

  /**
   * Handles change of a field in lane details.
   * @param {String} value - new value for input.
   * @param {string} key - field key.
   * @param {number} index - index of lane.
   */
  const changeHandler = (value, key, index) => {
    var temp = lane_details.map((l, i) => {
      if (i === index) {
        l[key] = value;
      }
      return l;
    });
    setlane_details(temp);
  };

  /**
   * Handles change of a transporter field in lane details.
   * @param {String} value - new value for input.
   * @param {Object} transporter - transporter object.
   * @param {string} key - field key.
   * @param {number} index - index of lane.
   */
  const changeHandlerfortransporter = (value, transporter, key, index) => {
    var temp = lane_details.map((l, i) => {
      if (i === index) {
        l.transporter_details.map((t) => {
          if (
            t.transporter.transporter_id ===
            transporter.transporter.transporter_id
          ) {
            t[key] = parseInt(value);
          }
          return t;
        });
      }
      return l;
    });
    setlane_details(temp);
  };

  /**
   * Checks if total business share for transporters is 100%.
   * @param {Array<Object>} transporter_details - array of transporter details.
   * @returns {boolean} - True if business share is not 100%, false otherwise.
   */
  const getbusinessshare = (transporter_details) => {
    var business_share = 0;
    transporter_details.map((transporter) => {
      business_share = business_share + transporter.business_share;
    });
    if (business_share !== 100) {
      return true;
    } else {
      return false;
    }
  };

  /**
   * Checks if all transporter names are selected.
   * @param {Array<Object>} transporter_details - array of transporter details.
   * @returns {boolean} - True if a transporter name is missing, false otherwise.
   */
  const check_transporter_name = (transporter_details) => {
    for (var i = 0; i < transporter_details?.length; i++) {
      if (!transporter_details[i]?.transporter?.transporter_id) {
        return true;
      }
    }
    return false;
  };

  /**
   * Checks if all transporter rates are valid.
   * @param {Array<Object>} transporter_details - array of transporter details.
   * @returns {boolean} - True if a transporter rate is missing or zero, false otherwise.
   */
  const check_transporter_rate = (transporter_details) => {
    for (var i = 0; i < transporter_details?.length; i++) {
      if (!transporter_details[i].rate) {
        return true;
      }
      if (transporter_details[i].rate === 0) {
        return true;
      }
    }
    return false;
  };

  /**
   * Validates lane details.
   *
   * @param {Array<Object>} lanes - array of lane details.
   * @returns {boolean} - True if lane details are valid, false otherwise.
   */
  const validate = (lanes) => {
    for (var i = 0; i < lanes.length; i++) {
      if (getbusinessshare(lanes[i].transporter_details)) {
        toast.info("Please update your business share as 100%");
        return false;
      }
      if (!lanes[i].origin || lanes[i].origin === null) {
        toast.info("Please add origin");
        return false;
      }
      if (!lanes[i].destination || lanes[i].destination === null) {
        toast.info("Please add destination");
        return false;
      }
      if (check_transporter_name(lanes[i].transporter_details)) {
        toast.info("Please Select Transporters from dropdown");
        return false;
      }
      if (check_transporter_rate(lanes[i].transporter_details)) {
        toast.info("Please add valid rate");
        return false;
      }
    }
    return true;
  };
  const splitIndents = (newindents) => {
    let splittedIndents = [];
    newindents.forEach((lane) => {
      const trucks = parseInt(lane.truck_required, 10);
      lane.shortlisted_transporters &&
        lane.shortlisted_transporters.length > 0 &&
        lane.shortlisted_transporters.map((data) => {
          data.rank && typeof data.rank === "string"
            ? data.rank.includes("L")
              ? (data.rank = data.rank.replace(/L(?=.*L)/g, ""))
              : (data.rank = `L${data.rank}`)
            : (data.rank = `L${data.rank}`);
        });

      for (let i = 0; i < trucks; i++) {
        const newData = {
          ...lane,
          truck_required: "1", // Set truck required to "1" for each new entry
        };
        splittedIndents.push(newData);
      }
    });
    return splittedIndents;
  };
  /**
   * Saves and confirms lane details.
   */
  const saveandconfirm = () => {
    if (isBulkUpload) {
      if (floatFromFM === "yes") {
        setshow(true);
        const checkFmLanes = lane_details.map((lane) => {
          return {
            origin: lane.origin,
            destination: lane.destination,
            truck_type: lane.truck_type,
            placement_date: lane.placement_date,
            volume: lane.volume,
            shortlisted_transporters: lane.transporter_details.map((t) => ({
              ...t.transporter,
              rate: t.rate,
              business_share: t.business_share,
              rank: `L${t.rank}`,
              is_shortlist: true,
            })),
          };
        });
        axios
          .post(`${Urls.freight_master}?action=check_all_lanes`, checkFmLanes)
          .then((res) => {
            if (
              res &&
              res.data &&
              res.data.exists &&
              res.data.exists.length > 0
            ) {
              setExistingLanes(res.data.exists);
              setshow(false);
              setStep(6);
            } else if (res && res.data && res.data.error) {
              toast.error(res.data.error);
              setshow(false);
            }
          })
          .catch((err) => {
            console.error(err, "err");
            setshow(false);
          });
      } else {
        setshow(true);
        const expiryHours =
          companySettingData &&
            companySettingData.indent &&
            companySettingData.indent.indent_expiry &&
            companySettingData.indent.indent_auto_expiry_enable === "yes"
            ? parseInt(companySettingData.indent.indent_expiry)
            : 0;

        const finalPayload = lane_details.map((lane) => {
          const placementDate = lane.placement_date.$date
            ? new Date(lane.placement_date.$date).toISOString().split("T")[0]
            : new Date().toISOString().split("T")[0];

          let expiryDateTime;
          if (expiryHours > 0) {
            const expiryDate = new Date();
            expiryDate.setHours(expiryDate.getHours() + expiryHours);
            const year = expiryDate.getFullYear();
            const month = ("0" + (expiryDate.getMonth() + 1)).slice(-2);
            const day = ("0" + expiryDate.getDate()).slice(-2);
            const hour = ("0" + expiryDate.getHours()).slice(-2);
            const minute = ("0" + expiryDate.getMinutes()).slice(-2);
            const second = ("0" + expiryDate.getSeconds()).slice(-2);
            expiryDateTime = `${year}-${month}-${day} ${hour}:${minute}:${second}.000000`;
          } else {
            expiryDateTime = null;
          }
          return {
            origin: lane.origin,
            destination: lane.destination,
            truck_types: [lane.truck_type],
            truck_required: Number(lane.volume),
            placement_date: placementDate,
            shortlisted_transporters: lane.transporter_details.map((t) => ({
              ...t.transporter,
              rate: t.rate,
              business_share: t.business_share,
              rank: `L${t.rank}`,
              is_shortlist: true,
            })),
            expiry_date: expiryDateTime,
          };
        });
        axios
          .post(Urls.createMultipleIndent, {
            indents: splitIndents(finalPayload),
          })
          .then((res) => {
            if (res && res.data && res.data.error) {
              toast.error(res.data.error);
              return false;
            } else {
              setStep(1)
              setValidationErrors()
              toast.success("Indent Floated Successfully");
              document.getElementById("close_contactus1").click();
            }
            setshow(false);
          })
          .catch((err) => {
            console.error(err, "err");
            setshow(false);
          });
      }
    } else {
      Activity([
        {
          screen: "Company Profile",
          module: "Freight Master Upload Excel",
          user_activity: `Review and Confirm Screen: User clicked on Confirm Button`,
          timestamp: currentRequestTimeStamp(), "userEmail": userDetails?.email, "userName": userDetails?.user_name
          , companyname: userDetails.company_name ? userDetails.company_name : userDetails.email ? userDetails.email.split("@")[1].split(".")[0] : ""
        },
      ]);
      TrackMixPanel({
        ModuleName: "masters",
        ScreenName: "freight master",
        Definition: "freight master popup review and confirm screen: user clicked on confirm button",
        Data: "none",
      });
      // setshow(true);
      const _lane_details = lane_details?.map((lane) => {
        return {
          ...lane,
          baseline_rate:
            lane?.baseline_rate && !isNaN(lane?.baseline_rate)
              ? parseInt(lane?.baseline_rate)
              : "",
          market_rate:
            lane?.market_rate && !isNaN(lane?.market_rate)
              ? parseInt(lane?.market_rate)
              : "",
          site_rate:
            lane?.site_rate && !isNaN(lane?.site_rate)
              ? parseInt(lane?.site_rate)
              : "",
          challenge_price:
            lane?.challenge_price && !isNaN(lane?.challenge_price)
              ? parseInt(lane?.challenge_price)
              : "",
          distance:
            lane?.distance && !isNaN(lane?.distance)
              ? parseInt(lane?.distance)
              : "",
        };
      });
      if (validate(lane_details)) {
        setshow(true);
        Axios.post(`${Urls.freight_master}?action=create_freight_master`, {
          excel_id: excel_details.excel_id,
          lanes: _lane_details,
        })
          .then((res) => {
            setshow(false);
            if (res.data.status === "failed") {
              const errorMsg = res.data.id?.error || "Failed to upload lanes.";
              toast.error(errorMsg);
              return;
            }
            toast.success(
              "Lanes Uploaded. We will update once your freight master is ready."
            );
            // console.log(res.data)

            sendMailToMasters(
              "Freight Master",
              emailTemplate,
              superAdmins,
              {
                action: "New File Uploaded",
                lane: "",
              },
              setshow,
              userDetails?.user_name || userDetails?.email?.split("@")[0]
            );
            next_page({
              data: "completed",
              excel_id: excel_details.excel_id,
              key: "page",
            });
            const activity = {
              lanes_uploaded: _lane_details?.length
            }
            closeModal("close_contactus1");
            MastersChangeLog(
              "New File Uploaded",
              "freight_master",
              userDetails.email,
              userDetails.user_id,
              companyProfile.domain_data.company_id,
              activity
            );
          })
          .catch((e) => {
            console.error(e);
            setshow(false);
          });
      }
      // setshow(false);
    }
  };

  /**
   * Retrieves base line percentage for transporter details.
   * @param {Array<Object>} transporter_details - array of transporter details.
   * @returns {JSX.Element | null} - base line percentage component or null.
   */
  const getbaselineperc = (transporter_details) => {
    var business_share = 0;
    transporter_details.map((transporter) => {
      business_share = business_share + transporter.business_share;
    });
    if (business_share !== 100) {
      return (
        <span className={classes["business_error"]}>
          Business Share must be 100%
        </span>
      );
    }
    return null;
  };

  /**
   * Cancels process and navigates to completed step.
   */
  const cancelProcess = () => {
    if (window.confirm("Are you sure to cancel?")) {
      next_page({
        data: "completed",
        excel_id: excel_details.excel_id,
        key: "page",
      }); //Imp
      document.getElementById("close_contactus1").click();
      toast.success("Process Cancelled Successfully");
    }
  };

  const hasAnyLocationCode = (type) => {
    return lane_details.some((lane) => {
      const code =
        type === "origin"
          ? lane?.origin?.location_code
          : lane?.destination?.location_code;

      return code !== undefined && code !== null && String(code).trim() !== "";
    });
  };


  const hasAnyLocationState = (type) => {
    return lane_details.some((lane) => {
      const state =
        type === "origin"
          ? lane?.origin?.location?.state
          : lane?.destination?.location?.state;

      return state !== undefined && state !== null && String(state).trim() !== "";
    });
  };

  const getMaxTransporterCount = () => {
    if (!lane_details || lane_details.length === 0) return 0;

    return Math.max(
      ...lane_details.map((lane) =>
        Array.isArray(lane?.transporter_details)
          ? lane.transporter_details.length
          : 0
      )
    );
  };

  const showOriginCodeColumn = hasAnyLocationCode("origin");
  const showDestinationCodeColumn = hasAnyLocationCode("destination");
  const showOriginStateColumn = hasAnyLocationState("origin");
  const showDestinationStateColumn = hasAnyLocationState("destination");
  const maxTransporterColumns = getMaxTransporterCount();

  return (
    <center>
      {/* <Loader show={show}/> */}
      <div
        style={{
          border: "1px solid grey",
          padding: "1%",
          minHeight: isBulkUpload ? "63vh" : "",
          maxHeight: isBulkUpload ? "65vh" : "",
        }}
      >
        <div
          className={`${classes["lanestable"]}`}
          style={{
            minHeight: isBulkUpload ? "55vh" : "150px",
            maxHeight: isBulkUpload ? "55vh" : "",
          }}
        >
          <div className={`${classes["headers"]}`}>
            <div className={classes["baseline_rate"]}>Sr.No.</div>
            {showOriginCodeColumn && (
              <div className={classes["origin"]}>Origin ID</div>
            )}

            <div className={classes["origin"]}>Origin</div>

            {showOriginStateColumn && (
              <div className={classes["origin_state"]}>Origin State</div>
            )}
            {showDestinationCodeColumn && (
              <div className={classes["destination"]}>Destination ID</div>
            )}
            <div className={classes["destination"]}>Destination</div>
            {showDestinationStateColumn && (
              <div className={classes["destination_state"]}>
                Destination State
              </div>
            )}
            <div className={classes["truck_type"]}>Truck Type</div>
            <div className={classes["volume"]}>Volume</div>
            <div className={classes["transit_time"]}>Transit Time</div>
            <div className={classes["baseline_rate"]}>Distance</div>
            <div className={classes["baseline_rate"]}>Unit</div>
            <div className={classes["baseline_rate"]}>Zone</div>
            <div className={classes["baseline_rate"]}>Route Code</div>
            <div className={classes["baseline_rate"]}>Baseline</div>
            <div className={classes["baseline_rate"]}>Market Rate</div>
            <div className={classes["baseline_rate"]}>Site Rate</div>
            <div className={classes["baseline_rate"]}>Challenge Price</div>
            {Array.from({ length: maxTransporterColumns }).map((_, i) => {
              return (
                <React.Fragment key={`transporter-header-${i}`}>
                  <div className={classes["transporter_name"]}>
                    L{i + 1} Transporter Name
                  </div>
                  <div className={classes["transporter_rate"]}>
                    L{i + 1} Transporter Rate
                  </div>
                  <div className={classes["transporter_share"]}>
                    L{i + 1} Business Share
                  </div>
                </React.Fragment>
              );
            })}
          </div>
          <div
            className={classes["lane_details"]}
            style={{ position: "relative" }}
          >
            <div className="position-absolute w-100 h-100">
              <Loader show={show} />
            </div>
            {lane_details.map((lane, index) => {
              return (
                <div className={`${classes["lanes"]}`}>
                  <div className={classes["baseline_rate"]}>{index + 1}</div>

                  {showOriginCodeColumn && (
                    <div className={classes["origin"]}>
                      {lane?.origin?.location_code
                        ? lane?.origin?.location_code
                        : "-"}
                    </div>
                  )}
                  <div className={classes["origin"]}>
                    <AutoComplete
                      key="origin_key"
                      module_key="indents"
                      user_identifier={userDetails?.profile_company_id}
                      value={
                        lane?.origin?.location_name
                          ? {
                            label: lane.origin.location_name,
                            value: lane.origin.location_name,
                          }
                          : null
                      }
                      placeholder="Origin Code"
                      onChange={(val) => {
                        setlane_details(
                          lane_details.map((l, i) =>
                            i === index
                              ? {
                                ...l,
                                origin: {
                                  ...l.origin,
                                  location_name: val,   // typing
                                },
                              }
                              : l
                          )
                        );
                      }}
                      onSelect={(obj) => {
                        setlane_details(
                          lane_details.map((l, i) =>
                            i === index
                              ? {
                                ...l,
                                origin: obj,   // full object from API
                              }
                              : l
                          )
                        );
                      }}
                    />
                  </div>

                  {showOriginStateColumn && (
                    <div className={classes["origin_state"]}>
                      {lane?.origin &&
                        lane?.origin?.location &&
                        lane?.origin?.location?.state
                        ? lane?.origin?.location?.state
                        : "-"}
                    </div>)}
                  {showDestinationCodeColumn && (
                    <div className={classes["destination"]}>
                      {lane?.destination?.location_code
                        ? lane?.destination?.location_code
                        : "-"}
                    </div>
                  )}
                  <div className={classes["destination"]}>
                    <AutoComplete
                      key="destination_key"
                      module_key="indents"
                      user_identifier={userDetails?.profile_company_id}
                      value={
                        lane?.destination?.location_name
                          ? {
                            label: lane.destination.location_name,
                            value: lane.destination.location_name,
                          }
                          : null
                      }
                      placeholder="Destination Code"
                      onChange={(val) => {
                        setlane_details(
                          lane_details.map((l, i) =>
                            i === index
                              ? {
                                ...l,
                                destination: {
                                  ...l.destination,
                                  location_name: val,   // typing
                                },
                              }
                              : l
                          )
                        );
                      }}
                      onSelect={(obj) => {
                        setlane_details(
                          lane_details.map((l, i) =>
                            i === index
                              ? {
                                ...l,
                                destination: obj,   // full API object
                              }
                              : l
                          )
                        );
                      }}
                    />
                  </div>
                  {showDestinationStateColumn && (
                    <div className={classes["destination_state"]}>
                      {lane?.destination &&
                        lane?.destination?.location &&
                        lane.destination.location?.state
                        ? lane.destination.location.state
                        : ""}
                    </div>)}
                  <div className={classes["truck_type"]}>
                    {lane.truck_type ? (
                      <Select
                        options={truckTypes}
                        isMulti={false}
                        onChange={(value) =>
                          onChangeTruckType(value, lane, index)
                        }
                        className={"Truck_Type_Select"}
                        classNamePrefix={"Truck_Prefix"}
                        defaultValue={lane.truck_type}
                      />
                    ) : null}
                  </div>
                  <div className={classes["volume"]}>
                    <input
                      type="number"
                      className={classes["textfields"]}
                      defaultValue={lane.volume}
                      onChange={(e) =>
                        changeHandler(e.target.value, "volume", index)
                      }
                    />
                  </div>
                  <div className={classes["transit_time"]}>
                    <input
                      type="number"
                      className={classes["textfields"]}
                      defaultValue={lane.transit_time}
                      onChange={(e) =>
                        changeHandler(e.target.value, "transit_time", index)
                      }
                    />
                  </div>
                  <div className={classes["baseline_rate"]}>
                    <input
                      type="number"
                      onKeyDown={(evt) =>
                        ["e", "E", "+", "-"].includes(evt.key) &&
                        evt.preventDefault()
                      }
                      className={classes["textfields"]}
                      defaultValue={lane.distance}
                      onChange={(e) =>
                        changeHandler(e.target.value, "distance", index)
                      }
                    />
                  </div>
                  <div className={classes["baseline_rate"]}>
                    <input
                      type="text"
                      className={classes["textfields"]}
                      defaultValue={lane.unit}
                      onChange={(e) =>
                        changeHandler(e.target.value, "unit", index)
                      }
                    />
                  </div>
                  <div className={classes["baseline_rate"]}>
                    <input
                      type="text"
                      className={classes["textfields"]}
                      defaultValue={lane.zone}
                      onChange={(e) =>
                        changeHandler(e.target.value, "zone", index)
                      }
                    />
                  </div>
                  <div className={classes["baseline_rate"]}>
                    <input
                      type="text"
                      className={classes["textfields"]}
                      defaultValue={lane.route_code}
                      onChange={(e) =>
                        changeHandler(e.target.value, "route_code", index)
                      }
                    />
                  </div>
                  <div className={classes["baseline_rate"]}>
                    <input
                      type="number"
                      onKeyDown={(evt) =>
                        ["e", "E", "+", "-"].includes(evt.key) &&
                        evt.preventDefault()
                      }
                      className={classes["textfields"]}
                      defaultValue={
                        lane.baseline_rate === 0 ? "" : lane.baseline_rate
                      }
                      onChange={(e) =>
                        changeHandler(e.target.value, "baseline_rate", index)
                      }
                    />
                  </div>
                  <div className={classes["baseline_rate"]}>
                    <input
                      onKeyDown={(evt) =>
                        ["e", "E", "+", "-"].includes(evt.key) &&
                        evt.preventDefault()
                      }
                      type="number"
                      className={classes["textfields"]}
                      defaultValue={
                        lane.market_rate === 0 ? "" : lane.market_rate
                      }
                      onChange={(e) =>
                        changeHandler(e.target.value, "market_rate", index)
                      }
                    />
                  </div>
                  <div className={classes["baseline_rate"]}>
                    <input
                      onKeyDown={(evt) =>
                        ["e", "E", "+", "-"].includes(evt.key) &&
                        evt.preventDefault()
                      }
                      type="number"
                      className={classes["textfields"]}
                      defaultValue={
                        lane?.site_rate === 0 ? "" : lane?.site_rate
                      }
                      onChange={(e) =>
                        changeHandler(e.target.value, "site_rate", index)
                      }
                    />
                  </div>
                  <div className={classes["baseline_rate"]}>
                    <input
                      type="number"
                      onKeyDown={(evt) =>
                        ["e", "E", "+", "-"].includes(evt.key) &&
                        evt.preventDefault()
                      }
                      className={classes["textfields"]}
                      defaultValue={
                        lane.challenge_price === 0 ? "" : lane?.challenge_price
                      }
                      onChange={(e) =>
                        changeHandler(e.target.value, "challenge_price", index)
                      }
                    />
                  </div>

                  {/* {lane.transporter_details.map((transporter) => {
                    return (
                      <>
                        <div className={classes["transporter_name"]}>
                          <TransporterSuggest
                            transporter={transporter}
                            setcurrenttransporter={(e) => {
                              var temp = lane_details.map((l, i) => {
                                if (i === index) {
                                  l.transporter_details.map((t) => {
                                    if (
                                      t?.transporter?.transporter_id ===
                                      transporter?.transporter?.transporter_id
                                    ) {
                                      t.transporter = e;
                                    }
                                    return t;
                                  });
                                }
                                return l;
                              });
                              setlane_details(temp);
                            }}
                          />
                        </div>
                        <div className={classes["transporter_rate"]}>
                          <input
                            type="number"
                            className={classes["textfields"]}
                            defaultValue={transporter.rate}
                            onChange={(e) =>
                              changeHandlerfortransporter(
                                e.target.value,
                                transporter,
                                "rate",
                                index
                              )
                            }
                          />
                          {transporter.rate === 0 ||
                            transporter.rate === null ||
                            !transporter.rate ? (
                            <label style={{ color: "red", fontSize: "10px" }}>
                              Rate cannot be empty
                            </label>
                          ) : null}
                        </div>
                        <div className={classes["transporter_share"]}>
                          <input
                            type="number"
                            className={classes["textfields"]}
                            defaultValue={transporter.business_share}
                            onChange={(e) =>
                              changeHandlerfortransporter(
                                e.target.value,
                                transporter,
                                "business_share",
                                index
                              )
                            }
                          />
                          {getbaselineperc(lane.transporter_details)}
                        </div>
                      </>
                    );
                  })} */}
                  {Array.from({ length: maxTransporterColumns }).map((_, transporterIndex) => {
                    const transporter = lane?.transporter_details?.[transporterIndex];

                    if (!transporter) {
                      return (
                        <React.Fragment key={`empty-transporter-${index}-${transporterIndex}`}>
                          <div className={classes["transporter_name"]}>-</div>
                          <div className={classes["transporter_rate"]}>-</div>
                          <div className={classes["transporter_share"]}>-</div>
                        </React.Fragment>
                      );
                    }

                    return (
                      <React.Fragment key={`transporter-${index}-${transporterIndex}`}>
                        <div className={classes["transporter_name"]}>
                          <TransporterSuggest
                            transporter={transporter}
                            setcurrenttransporter={(e) => {
                              const temp = lane_details.map((l, i) => {
                                if (i === index) {
                                  return {
                                    ...l,
                                    transporter_details: l.transporter_details.map((t, ti) => {
                                      if (ti === transporterIndex) {
                                        return {
                                          ...t,
                                          transporter: e,
                                        };
                                      }

                                      return t;
                                    }),
                                  };
                                }

                                return l;
                              });

                              setlane_details(temp);
                            }}
                          />
                        </div>

                        <div className={classes["transporter_rate"]}>
                          <input
                            type="number"
                            className={classes["textfields"]}
                            defaultValue={transporter.rate}
                            onChange={(e) =>
                              changeHandlerfortransporter(
                                e.target.value,
                                transporter,
                                "rate",
                                index
                              )
                            }
                          />

                          {transporter.rate === 0 ||
                            transporter.rate === null ||
                            !transporter.rate ? (
                            <label style={{ color: "red", fontSize: "10px" }}>
                              Rate cannot be empty
                            </label>
                          ) : null}
                        </div>

                        <div className={classes["transporter_share"]}>
                          <input
                            type="number"
                            className={classes["textfields"]}
                            defaultValue={transporter.business_share}
                            onChange={(e) =>
                              changeHandlerfortransporter(
                                e.target.value,
                                transporter,
                                "business_share",
                                index
                              )
                            }
                          />

                          {getbaselineperc(lane.transporter_details)}
                        </div>
                      </React.Fragment>
                    );
                  })}
                </div>
              );
            })}
          </div>
        </div>
        <div className={`d-flex justify-content-center mt-3`}>
          {/* <button className={`btn btn-sm btn-primary`} onClick={e => {}}>Previous</button> */}
          {/* <button className={`btn btn-sm btn-success`} onClick={() => {
                        console.log(lane_details)
                    }}>Save</button> */}
          <button
            className="btn btn-sm btn-danger mr-3"
            disabled={show}
            onClick={(e) => cancelProcess()}
          >
            Cancel
          </button>
          <button
            className="btn btn-sm btn-primary mr-3"
            disabled={show}
            onClick={(e) => {
              setPreviosStep(4);
              setStep(3);
            }}
          >
            Previous
          </button>
          <button
            className={`btn btn-sm btn-success`}
            disabled={show}
            onClick={(e) => saveandconfirm()}
          >
            {isBulkUpload === true ? "Create Indents" : "Save and Confirm"}
          </button>
        </div>
      </div>
    </center>
  );
};

export default ConfirmLanes;
